import { memo } from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateType } from 'queries';

type Props = {
  estateType: EstateType;
};

const useStyles = makeStyles(() => ({
  estateTypeChipBlack: {
    color: '#596674',
    backgroundColor: '#F5F5F5',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '13px',
    padding: '8px',
    gap: '6px',
  },
  estateTypeChipPurple: {
    color: '#5925DC',
    backgroundColor: '#F4F3FF',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '13px',
    padding: '8px',
    gap: '6px',
  },
  estateTypeChipBlue: {
    color: '#175CD3',
    backgroundColor: '#EFF8FF',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '13px',
    padding: '8px',
    gap: '6px',
  },
}));

const sx = {
  estateTypeChipBlackDot: { '&&': { color: '#596674', width: '6px', height: '6px' } },
  estateTypeChipPurpleDot: { '&&': { color: '#5925DC', width: '6px', height: '6px' } },
  estateTypeChipBlueDot: { '&&': { color: '#175CD3', width: '6px', height: '6px' } },
};

const EstateTypeChip = ({ estateType }: Props) => {
  const classes = useStyles();

  const getClassNames = (estateType: EstateType) => {
    const estateTypeChipBlack: string[] = [EstateType.Truadmin, EstateType.Trustadmin];

    const estateTypeChipPurple: string[] = [EstateType.Truplanning];

    const estateTypeChipBlue: string[] = [EstateType.Truproxy];

    if (estateTypeChipBlack.includes(estateType)) {
      return [classes.estateTypeChipBlack, sx.estateTypeChipBlackDot];
    } else if (estateTypeChipPurple.includes(estateType)) {
      return [classes.estateTypeChipPurple, sx.estateTypeChipPurpleDot];
    } else if (estateTypeChipBlue.includes(estateType)) {
      return [classes.estateTypeChipBlue, sx.estateTypeChipBlueDot];
    } else {
      return [classes.estateTypeChipBlack, sx.estateTypeChipBlackDot];
    }
  };

  const [textClass, dotClass] = getClassNames(estateType);

  return (
    <Chip
      className={textClass as string}
      icon={
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <CircleIcon sx={dotClass as any} />
      }
      label={estateType.toLowerCase()}
      size="small"
    />
  );
};

export default memo(EstateTypeChip);
